module.exports = __webpack_public_path__ + "media/images/logo/logo-wh-56dc9306073c7ef93e1076196c9c4f5c.png";